import { render, staticRenderFns } from "./ContactComponentView.vue?vue&type=template&id=063c156d&scoped=true"
import script from "./ContactComponentView.vue?vue&type=script&lang=js"
export * from "./ContactComponentView.vue?vue&type=script&lang=js"
import style0 from "./ContactComponentView.vue?vue&type=style&index=0&id=063c156d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c156d",
  null
  
)

export default component.exports